import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import ReportSettings from "@/features/report/report-settings";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/report/",
)({
  component: ReportPage,
  beforeLoad: ({ context }) => {
    const canReadReport = context.ability.can("read", "Report");

    if (!canReadReport) {
      console.error("User does not have permission to read reports");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
});

function ReportPage() {
  const { museumId } = Route.useParams();

  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Rapporter</Trans>
        </h1>
      </Flex>

      <ReportSettings museumId={museumId} />
    </Box>
  );
}
